import React from 'react'
import { useContext } from 'react';
import { AppContext } from '../../../components/AppProvider';
import { useEffect } from 'react';
import { closeLayerFn, openLayerFn } from './../../Layout';
import { inputDotInDate, stringToTelNo } from './../../../modules/utils/CheckLogic';
import { PostApi1916 } from './../../../modules/network/padoPost';
import { _O } from '../../../modules/utils';
import { Base64 } from 'js-base64';
import { setCookie } from '../../../modules/utils/cookie';
import styled from "styled-components";

import IcCheckOn from "../../../resources/images/icon/checkbox/checkbox_select.svg";

export default (props) => {
  const { hpKey, hsptNm, setSearchType, handleAlert } = props;
  const { userinfo, phonecfg, cfg } = useContext(AppContext);

  // 등록 이벤트
  const clickEventHandler = (type) => {
    if (type === "ADD") {
      if ($("#privateApply").is(":checked") == true) {
        connectRequest();
        closeLayerFn($(".confirm-layer"));
      } else {
        handleAlert("", "개인정보동의에 체크하세요 .");
      }
    } else {
      _O.Open("/updataHsptCnntInfo/" + hpKey + "/" + hsptNm + "/U/" + Base64.encode(JSON.stringify(userinfo)));
      closeLayerFn($(".confirm-layer"));
    }
  };

  const connectRequest = () => {
    PostApi1916(userinfo, cfg, phonecfg, hpKey, "I", "", userinfo)
      .then((res) => {
        if (res.resultCode === "E000") {
          // 연동병원 이동
          handleAlert("", "병원 등록 성공");
          setSearchType(0);
          // 병원 등록 후 메인팝업 재노출
          setCookie("showCnntHspt", "", 0);
        } else {
          handleAlert("", "병원 등록에 실패하였습니다.");
        }
      })
      .catch((err) => {
        console.log("err ::", err);
      });
  };

  return (
    <div className="blacklayer-container confirm-layer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div className={"blgrn-box vertical"}>
          <div className="blgr-title">병원등록정보 확인</div>

          <div style={{ paddingTop: "15px", color: "#fff", textAlign: "left" }}>
            <div>{hsptNm}을 연동병원으로 등록합니다</div>
          </div>

          <div
            className="save-question-box"
            style={{ padding: "0", textAlign: "left" }}>
            <div style={{ paddingTop: "15px" }}>
              <p>{"<병원등록정보>"}</p>
              <p>-이름: {userinfo.userName}</p>
              <p>-성별: {userinfo.sex === "1" ? "남" : "여"}</p>
              <p>-생년월일: {inputDotInDate(userinfo.birth)}</p>
              <p>-휴대폰번호: {stringToTelNo(userinfo.userPhone)}</p>
            </div>

            <div style={{ paddingTop: "15px" }}>
              수정은 의료진 대면 확인이 필요합니다.
              <br />
              해당 정보로 등록하시겠습니까?
            </div>

            <div style={{ paddingTop: "15px", display: "flex" }}>
              <div>
                <ItemChecked id="privateApply" type={"checkbox"} />
              </div>
              <div>개인정보활용에 동의합니다.</div>
            </div>

            <div
              style={{
                paddingTop: "15px",
                fontSize: "16px",
                textDecoration: "underline",
              }}
              onClick={() => clickEventHandler("MOD")}>
              아니요, 정보를 수정하겠습니다.
            </div>
          </div>

          <div className="tbns-area" style={{ paddingTop: "30px" }}>
            <a
              className="btn-round gray"
              onClick={() => closeLayerFn($(".confirm-layer"))}>
              취소
            </a>
            <a
              className="btn-round wht"
              id="targetLogout"
              onClick={() => clickEventHandler("ADD")}>
              등록
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
// 취소/확인 다이얼로그 ]]

const ItemChecked = styled.input`
  appearance: none !important;
  border: 1px solid #e0e0e0;
  border-radius: 1.5px;
  background-color: #fff !important;
  width: 18px;
  height: 18px;

  margin-right: 10px;

  vertical-align: middle;

  box-sizing: border-box;

  :checked {
    background-image: url(${IcCheckOn});
    background-color: #fff !important;
    background-size: 100% !important;
    background-position: 50%;
    background-repeat: no-repeat;
  }
`;